/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { isEmpty } from './object';

export const queryVariables = () => {
    const query =        typeof window !== 'undefined'
        ? window.location.search.substring(1)
        : '';
    const vars = query ? query.split('&') : [];
    const varObject = {};
    if (!isEmpty(vars)) {
        // eslint-disable-next-line consistent-return
        vars.forEach((item) => {
            if (item) {
                const pair = item.split('=');
                // eslint-disable-next-line prefer-destructuring
                varObject[pair[0]] = pair[1];
            }
        });
    }
    return varObject;
};

export const queryVariable = (variable) => {
    const query =        typeof window !== 'undefined'
        ? window.location.search.substring(1)
        : '';
    const vars = query ? query.split('&') : [];
    if (!isEmpty(vars)) {
        // eslint-disable-next-line consistent-return
        vars.forEach((item) => {
            if (item) {
                const pair = item.split('=');
                if (pair[0] === variable) {
                    return pair[1];
                }
            }
        });
    }
    return false;
};
